import { Component, Inject } from '@angular/core';
import { Sensor } from '../../../../model/sensor';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ArrayUtils } from '../../../../utils/arrayUtils';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ExecutionQTestsService } from '../../../../services/execution-q-tests.service';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from '../../../../services/snackBar.service';
import { SpinnerService } from '../../../../services/spinner.service';

export interface DialogDataConfirmSave {
  idExecutionTest: number;
  idEssay: number;
  idEssayVariable: number;
  sensors: Sensor[];
}

@Component({
    selector: 'app-execution-q-edit-dialog-correct-sensor',
    templateUrl: './execution-q-edit-dialog-correct-sensor.component.html',
    styleUrl: './execution-q-edit-dialog-correct-sensor.component.scss',
    standalone: false,
})
export class ExecutionQEditDialogCorrectSensorComponent {
    checks: Map<Sensor, boolean>;
   
     constructor(
       public dialogRef: MatDialogRef<ExecutionQEditDialogCorrectSensorComponent>,
       @Inject(MAT_DIALOG_DATA) public data: DialogDataConfirmSave,
       private executionQTestsService: ExecutionQTestsService,
       private translate: TranslateService,
       private snackBarService: SnackBarService,
       private spinnerService: SpinnerService) {
   
       this.checks = new Map<Sensor, boolean>();
   
       const sensors = this.data.sensors;
       const allUnchecked = !ArrayUtils.isEmpty(sensors) && sensors.every(s => !s.corrected);
   
       sensors.forEach(s => this.checks.set(s, s.corrected || allUnchecked));
     }
   
     onOkClick(): void {
       this.spinnerService.show();
   
       const data = this.data;
       const checks: number[] = [];
   
       this.checks.forEach((ch: boolean, sen: Sensor) => {
         if (ch) {
           checks.push(sen.id);
         }
       })
   
       this.executionQTestsService.correctSensors(data.idExecutionTest, data.idEssayVariable, checks).subscribe(() => {
         this.spinnerService.hide();
         this.snackBarService.sendSuccess(this.translate.instant('executionEdit.dialog.correctSensor.form.ok') as string);
   
         this.dialogRef.close(this.data);
       }, () => {
         this.spinnerService.hide();
         this.snackBarService.sendError(this.translate.instant('executionEdit.dialog.correctSensor.form.error.generic') as string);
       });
     }
   
     onNoClick(): void {
       this.dialogRef.close();
     }
   
     isChecked(sensor: Sensor): boolean {
       return this.checks.get(sensor);
     }
   
     setChecked(sensor: Sensor, check: MatCheckboxChange): void {
       this.checks.set(sensor, check.checked);
     }
   
     setCheckedAll(check: MatCheckboxChange): void {
       this.checks.forEach((ch: boolean, sen: Sensor) => {
         this.checks.set(sen, check.checked)
       })
     }
   
   }
   